"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import WaveDropMetadata from "@/components/waves/drops/WaveDropMetadata";
import { useRouter } from "next/navigation";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
import { getDropVisibleMetadata } from "@/components/waves/drops/identityDisplay.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { WaveLeaderboardIdentity } from "../identity/WaveLeaderboardIdentity";
interface WaveLeaderboardDropContentProps {
  readonly drop: ExtendedDrop;
  readonly isCompetitionDrop?: boolean | undefined;
}
export const WaveLeaderboardDropContent: React.FC<WaveLeaderboardDropContentProps> = t0 => {
  const $ = _c(21);
  const {
    drop,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t2;
  if ($[0] !== drop.metadata || $[1] !== drop.wave) {
    t2 = getDropVisibleMetadata({
      wave: drop.wave,
      metadata: drop.metadata
    });
    $[0] = drop.metadata;
    $[1] = drop.wave;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const visibleMetadata = t2;
  let t3;
  if ($[3] !== router) {
    t3 = clickedDrop => {
      const href = getWaveRoute({
        waveId: clickedDrop.wave.id,
        serialNo: clickedDrop.serial_no,
        isDirectMessage: false,
        isApp: false
      });
      router.push(href);
    };
    $[3] = router;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onDropContentClick = t3;
  let t4;
  if ($[5] !== activePartIndex || $[6] !== drop || $[7] !== isCompetitionDrop || $[8] !== onDropContentClick) {
    t4 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} />;
    $[5] = activePartIndex;
    $[6] = drop;
    $[7] = isCompetitionDrop;
    $[8] = onDropContentClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== drop) {
    t5 = <WaveLeaderboardIdentity drop={drop} variant="responsive" cardVariant="chat" className="tw-mt-2 lg:tw-mt-0" />;
    $[10] = drop;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== visibleMetadata) {
    t6 = !!visibleMetadata.length && <WaveDropMetadata metadata={visibleMetadata} />;
    $[12] = visibleMetadata;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== drop) {
    t7 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><WaveDropReactions drop={drop} /></div>;
    $[14] = drop;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="-tw-mt-0.5 tw-flex tw-flex-col tw-gap-y-1">{t4}{t5}{t6}{t7}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp() {}
function _temp2() {}
function _temp3() {}